const EndpointEntries = 'https://383xti2nse.execute-api.eu-central-1.amazonaws.com/dev/entries';
const EndpointStats = 'https://383xti2nse.execute-api.eu-central-1.amazonaws.com/dev/stats';

export { EndpointEntries, EndpointStats };
